var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mainBox"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"left",style:({ height: _vm.leftHeight })},[_c('div',{ref:"enterDivWrap"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }